import React, { useState, useRef } from 'react';
import AuthHeader from '../../components/Navbar/AuthHeader';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { resendLoginOtp, verifyLoginOtp } from '../../actions/auth';
import { useDispatch, useSelector } from 'react-redux';
import LoadingScreen from '../../components/Loading/Loading';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

function LoginOtp() {
    const loading = useSelector((state) => state.loading.isLoading);
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef([]);
    const navigate = useNavigate();
    const sessionId = localStorage.getItem('sessionId');
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const dispatch = useDispatch();
    const loginEmail = localStorage.getItem('loginEmail');
    const [countdown, setCountdown] = useState(60); // 1min
    const [clientData, setClientData] = useState({ client: 'web' });

    React.useEffect(() => {
        const fetchClientData = async () => {
            if (Capacitor.isNativePlatform()) {
                try {
                    const info = await Device.getInfo();
                    const id = await Device.getId();
                    setClientData({
                        client: 'mobile',
                        device_name: info.name || info.model || 'Unknown Device',
                        device_id: id.identifier || 'Unknown ID',
                        platform: info.operatingSystem || 'unknown'
                    });
                } catch (deviceError) {
                    console.error("Failed to get device info:", deviceError);
                    setClientData({
                        client: 'mobile',
                        device_name: 'Unknown Device',
                        device_id: 'Unknown ID',
                        platform: Capacitor.getPlatform() || 'unknown'
                    });
                }
            }
        };
        fetchClientData();
    }, []);
    // const userAgent = navigator.userAgent;
    // console.log(userAgent);

    const formatCountdown = (seconds) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${secs}`;
    };

    React.useEffect(() => {
        if (countdown <= 0) return;

            const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown]);

    const handleInput = (e, index) => {
        const value = e.target.value;

        if (!/^\d*$/.test(value)) return; // only allow digits

        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }

        setHasError(false); // Allow resubmission
        setHasSubmitted(false);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text').trim();
        if (!/^\d{6}$/.test(paste)) return;

        const newOtp = paste.split('');
        setOtp(newOtp);

        inputRefs.current[5]?.focus(); // Move focus to last input

        setHasError(false);
        setHasSubmitted(false);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otp];
            if (otp[index] === "") {
                if (index > 0) {
                    newOtp[index - 1] = "";
                    setOtp(newOtp);
                    inputRefs.current[index - 1]?.focus();
                }
            } else {
                newOtp[index] = "";
                setOtp(newOtp);
            }
            setHasSubmitted(false);
        }
    };

    React.useEffect(() => {
        const otpValue = otp.join('');
        if (otpValue.length === 6 && !hasSubmitted && !hasError) {
            const email = loginEmail ? JSON.parse(loginEmail) : null;
            const credentials = {
                email,
                two_factor_code: otpValue,
                ...clientData
            };
            verifyLoginOtp(credentials, navigate, setIsLoading, setSuccessMessage, setErrorMessage, dispatch)
                .then(() => setHasSubmitted(true))
                .catch(() => {
                    setHasError(true);
                    setHasSubmitted(false);
                });
        }
    }, [otp]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!sessionId) {
        //     console.error("Session ID not found!");
        //     setTimeout(() => navigate('/login'), 0);
        //     return;
    

        const otpValue = otp.join("");

        if (otpValue.length !== 6) {
            setErrorMessage("Invalid OTP value");
            setHasError(true);
            setTimeout(() => setErrorMessage(""), 5000);
            return;
        }

        const email = loginEmail ? JSON.parse(loginEmail) : null;

        const credentials = {
            email: email,
            two_factor_code: otpValue,
            ...clientData
        }
            
        await verifyLoginOtp(credentials, navigate, setIsLoading, setSuccessMessage, setErrorMessage, dispatch);
    }    

    const handleResendOtp = async () => {
        const email = loginEmail ? JSON.parse(loginEmail) : null;
        await resendLoginOtp(email, navigate, setIsLoading, setSuccessMessage, setErrorMessage);
        setCountdown(60);
    };
    

    return (
        <>
            {/* {loading && <LoadingScreen />} */}
            <div style={{background: '#13053A',minHeight: '100vh'}}>
                <AuthHeader />
                <div className="auth__container padding__tb__30">
                    <div className='auth__container__box'>
                        <div>
                            <Link to='/login'>
                                <FaArrowLeftLong className='auth__back__arrow' />
                            </Link>
                        </div>

                        <h3> Verification Required </h3>
                        <p className='auth__text'>
                            Enter the 6-digit OTP code sent to your email.
                        </p>
                        <div className="">
                            <ProgressSteps currentStep={4} totalSteps={4} />
                        </div>

                        {successMessage && (
                            <div className="text-center text-success success-container">{successMessage}</div>
                        )}
                        {errorMessage && (
                            <div className="text-center text-danger error-container">{errorMessage}</div>
                        )}

                        <div className='auth__container__form w-full' style={{paddingLeft: 12, paddingRight: 12}}>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <div className='form__group'>
                                            <div className='mb-3'>
                                                <label htmlFor='otp' className='label__form'>
                                                    OTP Verification Code
                                                </label>
                                            </div>
                                            <div className="otp-input-container" style={{padding:0}}>
                                                {otp.map((digit, index) => (
                                                    <input
                                                        key={index}
                                                        type="text"
                                                        maxLength={1}
                                                        value={digit}
                                                        className='auth__form__input verify-code'
                                                        onChange={(e) => handleInput(e, index)}
                                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                                        onPaste={handlePaste}
                                                        ref={(el) => inputRefs.current[index] = el}
                                                        inputMode="numeric"
                                                        autoComplete="one-time-code"
                                                    />
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                    <div className='form__group mb-3 mt-4'>
                                        <button
                                            type='submit'
                                            className='btn btn__block'
                                        >
                                            {isLoading ? (
                                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : 'Continue'}
                                        </button>
                                    </div>
                                    <div className='mb-4'>
                                        {countdown > 0 ? (
                                            <div className="text-center small text-muted">
                                                <p>
                                                    Resend OTP Code in 
                                                    &nbsp;<span className="text-danger">
                                                        {formatCountdown(countdown)}
                                                    </span>
                                                </p>
                                            </div>
                                            ) : (
                                            <p className='text-center'>
                                                Didn't get OTP?{' '}
                                                <Link onClick={handleResendOtp} className='text-decoration-underline'>
                                                Resend here
                                                </Link>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginOtp;